<template>
  <v-container fluid pt-10 pl-0 pt-0 pb-10 ma-0>
    <v-row align="stretch" justify="space-around">
      <v-col md="6" sm="12">
        <v-card class="justify-center" elevation="2" outlined shaped>
          <v-card-title class="text-h2 justify-center">
            Get Your Results
          </v-card-title>
          <v-row gutter pa-0 ma-0 class="justify-center">
            <p class="text-h6">
              Complete the form below to get your results and recommendations
            </p>
          </v-row>
          <v-form v-model="valid">
            <v-row gutter pt-10 class="justify-center">
              <v-col cols="10">
                <v-text-field
                  label="First Name"
                  placeholder=""
                  prepend-inner-icon="mdi-account-arrow-left"
                  filled
                  v-model="fname"
                  :rules="[rules.required, rules.name]"
                  rounded
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row gutter pt-10 class="justify-center">
              <v-col cols="10">
                <v-text-field
                  label="Last Name"
                  prepend-inner-icon="mdi-account-arrow-right"
                  placeholder=""
                  filled
                  v-model="lname"
                  :rules="[rules.required, rules.name]"
                  rounded
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row gutter pt-10 class="justify-center">
              <v-col cols="10">
                <template v-if="SHOW_INVALID_EMAIL == true">
                  <p class="red--text">{{ INVALID_EMAIL }}</p>
                </template>
                <template v-if="SHOW_BLOCKED_EMAIL == true">
                  <p class="red--text">{{ BLOCKED_EMAIL }}</p>
                </template>
                <v-text-field
                  label="Business Email"
                  placeholder=""
                  v-model="email"
                  prepend-inner-icon="mdi-email"
                  :rules="[rules.required, rules.email]"
                  filled
                  rounded
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row gutter pt-10 class="justify-center">
              <v-col cols="10">
                <template v-if="SHOW_NUMBER_OUT_OF_RANGE == true">
                  <p class="red--text">{{ NUMBER_OUT_OF_RANGE }}</p>
                </template>
                <v-text-field
                  v-model="phone"
                  label="Phone Number"
                  placeholder=""
                  prepend-inner-icon="mdi-phone"
                  :rules="[
                    rules.phoneLen,
                    rules.required,
                    rules.number,
                    rules.phoneMax,
                  ]"
                  filled
                  rounded
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row gutter pt-10 pb-10 class="justify-center">
              <v-col cols="2">
                <v-btn
                  class="white--text"
                  color="#4d62ff"
                  @click="submitForm()"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
            <v-row gutter pa-0 ma-0 class="justify-center">
              <v-col cols="10">
                <p class="text-caption justify-center">
                  Precursor Security LTD needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy.
                </p>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      portalId: "25825875",
      formId: "80880f9b-b887-4eac-bc7a-f8e5b8839cb1",
      formURL:
        "https://api.hsforms.com/submissions/v3/integration/submit/25825875/80880f9b-b887-4eac-bc7a-f8e5b8839cb1/",
      phone: null,
      fname: null,
      lname: null,
      valid: false,
      email: null,
      rules: {
        number: (value) => !!/^\d+$/.test(value) || "Only numbers allowed",
        phoneMax: (value) => value.length <= 13 || "Max 13 characters",
        required: (value) => !!value || "Required.",
        name: (value) => !!/^[A-Za-z']+$/.test(value) || "Only Letters Allowed",
        phoneLen: (v) =>
          (v && v.length >= 10) ||
          "This field must have at least 10 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      BLOCKED_EMAIL: "Must be business email",
      NUMBER_OUT_OF_RANGE: "Invalid phone number",
      INVALID_EMAIL: "Invalid email",
      SHOW_INVALID_EMAIL: false,
      SHOW_NUMBER_OUT_OF_RANGE: false,
      SHOW_BLOCKED_EMAIL: false,
    };
  },
  methods: {
    handleError(errorResponse) {
      console.log(errorResponse.response.data.errors);
      let errors = errorResponse.response.data.errors;
      let i = 0;
      for (var err in errors) {
        let errcode = errors[err].errorType;
        console.log(errcode);
        if (errcode == "BLOCKED_EMAIL") {
          console.log(errcode);
          this.SHOW_BLOCKED_EMAIL = true;
        }
        if (errcode == "NUMBER_OUT_OF_RANGE") {
          console.log(errcode);
          this.SHOW_NUMBER_OUT_OF_RANGE = true;
        }
        if (errcode == "INVALID_EMAIL") {
          console.log(errcode);
          this.SHOW_INVALID_EMAIL = true;
        }
      }
    },
    async submitForm() {
      if (this.valid != false) {
        console.log("VALID");
        let requestData = {
          fields: [
            {
              objectTypeId: "0-1",
              name: "email",
              value: this.email,
            },
            {
              objectTypeId: "0-1",
              name: "firstname",
              value: this.fname,
            },
            {
              objectTypeId: "0-1",
              name: "lastname",
              value: this.lname,
            },
            {
              objectTypeId: "0-1",
              name: "phone",
              value: this.phone,
            },
          ],
          context: {
            pageName: "CE Quizz Sign Up",
          },
        };
        //SUBMIT FORM
        const rsp = await axios
          .post(this.formURL, requestData)
          .then((res) => res)
          .catch((rsp) => err);
        //console.log(err);
        if (rsp.status == 400) {
          this.handleError(rsp);
        }
        if (rsp.status == 200) {
          console.log("SUCCESS");
          this.$store.commit('setEmail', this.email);
          localStorage.setItem("sub", 1);
          this.$router.push("/e287b37a-7f07-4153-becd-27133e6d3c4c");
        }
      } else {
        console.log("NOT VALID");
      }
    },
  },
};
</script>
